import { throwErrorMsg } from "../../utils/throwErrorMsg"

export const plan = {
  reset(tag: "string", count: number) {
    throwErrorMsg("plan.reset")
  },
} as PlanDSL
